import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dayjs from 'dayjs';
// 引入高德地图插件
import AMapPlugin from './plugins/amap';

// 注册插件
Vue.use(ElementUI);
Vue.use(AMapPlugin); // 注册高德地图插件，使this.$createAMap生效

// 全局挂载dayjs
Vue.prototype.$dayjs = dayjs;
// 关闭生产提示
Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');